import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';
import { fieldBoxClass, fieldInnerClass } from './fieldStyles';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  invalid?: boolean;
  /** Texto o icono al inicio del campo ($, Bs.). Decorativo: el nombre lo da la etiqueta. */
  startSlot?: ReactNode;
  /** Texto o icono al final del campo (kg, %). */
  endSlot?: ReactNode;
  wrapperClassName?: string;
}

/** Campo de texto de 44 px con borde de 3:1 y anillo de foco en el contenedor. */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, startSlot, endSlot, className, wrapperClassName, disabled, ...rest },
  ref,
) {
  return (
    <div
      className={cn(fieldBoxClass, 'h-11', wrapperClassName)}
      data-invalid={invalid ? 'true' : undefined}
      data-disabled={disabled ? 'true' : undefined}
    >
      {startSlot ? <span className="shrink-0 text-sm text-fg-muted">{startSlot}</span> : null}
      <input
        ref={ref}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        className={cn(fieldInnerClass, 'h-full', className)}
        {...rest}
      />
      {endSlot ? <span className="shrink-0 text-sm text-fg-muted">{endSlot}</span> : null}
    </div>
  );
});
